import { defineComponent } from "../../../common/runtime/defineComponent.svelte";
import { props } from "./utils/props";

defineComponent({
  tag: "oc-sheet-v1",
  props,
  extendOptions: { asyncInit: true },
  component: () => import("./SheetV1.svelte"),
});
